<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visibleModal" width="1120px">
    <span class="custom-modal-title" slot="title">
      <h4>账号充值/转账</h4>
      <span v-if="list.length" class="selected-num">已选择{{ list.length }}个账号</span>
    </span>

    <el-form class="ghost-button-styles" label-width="110px">
      <el-form-item label="处理方式">
        <el-radio-group :value="form.batchType" @input="onHandleTypeChange">
          <el-radio-button v-for="item in batchTypeList" :key="item.value" ghost :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="统一设置" v-if="form.batchType === batchTypeEnum.RECHARGE">
        <el-radio-group>
          <el-radio-button ghost>设置充值</el-radio-button>
        </el-radio-group>

        <el-input
          style="margin-top: 10px"
          v-model="form.value"
          @blur="onRechargeValueConfirm"
          @keyup.enter.native="onRechargeValueConfirm"
          placeholder="请输入金额"
        >
          <template slot="prepend">
            <el-select v-model="form.type" style="width: 110px">
              <el-option v-for="item in [{ label: '实际充值', value: 1 }]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>

          <template slot="append">
            <el-select v-model="form.unit" style="width: 60px">
              <el-option v-for="item in [{ label: '元', value: 0 }]" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
        </el-input>
      </el-form-item>
    </el-form>

    <!-- 账号充值 -->
    <RechargeTable
      :list="list"
      @update-list="$emit('update:list', $event)"
      @clear-input="form.value = ''"
      v-if="visibleModal && form.batchType === batchTypeEnum.RECHARGE"
    ></RechargeTable>

    <!-- 账号转入 -->
    <TransferInTable
      :list="list"
      @update-list="$emit('update:list', $event)"
      v-if="visibleModal && form.batchType === batchTypeEnum.TRANSFER_IN"
    ></TransferInTable>

    <!-- 账号转出 -->
    <TransferOutTable
      :list="list"
      @update-list="$emit('update:list', $event)"
      v-if="visibleModal && form.batchType === batchTypeEnum.TRANSFER_OUT"
    ></TransferOutTable>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onModalCancel">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onModalConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import RechargeTable from './recharge-table.vue'
import TransferInTable from './transfer-in-table.vue'
import TransferOutTable from './transfer-out-table.vue'
import {
  batchTypeEnum,
  platformsList,
  batchTypeList,
  toutiaoFundTypeEnum,
  gdtFundTypeEnum,
  toutiaoFundType,
  gdtFundType,
  mediaTypeEnum
} from './data.js'
import { financeAccountOrderApply, getTransferAccountBalance, getValidTransferAccounts } from '@/api/ptom.data.model'

const twoDigitsRegExp = /^[0-9]+([.]{1}[0-9]{1,2})?$/
const getForm = () => ({ batchType: batchTypeEnum.RECHARGE, type: 1, unit: 0, value: '' })
// 1795185870349337
// 1795185870935114
// 1795185871540331
// 头条

// 40082120
// 40082121
// 40082122
// 腾讯
export default {
  components: { RechargeTable, TransferInTable, TransferOutTable },
  props: {
    visible: {
      type: Boolean
    },
    list: {
      type: Array
    }
  },
  provide() {
    return {
      calcBalance: this.calcBalance,
      getAccountRealtimeBalance: this.getAccountRealtimeBalance,
      getAvailableAccounts: () => this.availableAccounts,
      updateTableRow: this.updateTableRow,
      getTransferType: this.getTransferType
    }
  },
  data() {
    return {
      batchTypeEnum,
      batchTypeList,
      submitLoading: false,
      // 保存所有可用账号，以账号id为key
      availableAccounts: {},
      form: getForm()
    }
  },

  computed: {
    visibleModal: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    }
  },
  methods: {
    /**
     * @description: 获取当前行的可以账号
     * @param {*} row
     * @param {*} rowIdx
     */
    async updateTableRow(row, rowIdx) {
      // 切换处理方式时，会清空this.availableAccounts
      if (this.availableAccounts[row.accountId]) return
      this.$set(row, 'loading', true)
      // 获取当前行的可用账号
      const accounts = await this.getValidAccounts(row.accountId)
      this.$set(this.availableAccounts, row.accountId, accounts)

      this.$set(row, 'loading', false)

      if ([mediaTypeEnum.GDT, mediaTypeEnum.TOUTIAO].includes(row.mediaId)) {
        // 获取当前账号的实时余额
        const realtimeBalance = await this.getAccountRealtimeBalance(row, row.accountId)
        // 获取默认的资金类型
        const transferFundType = this.getTransferType(row)

        const newList = this.list.map((item, index) => {
          if (index === rowIdx) {
            return {
              ...item,
              loading: false,
              transferFundType,
              accountMoney: realtimeBalance.total_transfer_balance,
              bidCreditValid: realtimeBalance.bid_credit_valid,
              bidPrepayValid: realtimeBalance.bid_prepay_valid,
              grantValid: realtimeBalance.grant_valid,
              virturlValid: realtimeBalance.virturl_valid,
              specialGiftValid: realtimeBalance.special_gift_valid
            }
          }
          return item
        })
        this.$emit('update:list', newList)
      }
    },

    /**
     * @description: 获取当前行的资金类型（头条、腾讯广告）
     */
    getTransferType(row) {
      let transferFundType = ''

      if (row.mediaId === mediaTypeEnum.TOUTIAO) {
        transferFundType = toutiaoFundTypeEnum.CREDIT_BID
      }

      // 腾讯广告：默认授信余额
      if (row.mediaId === mediaTypeEnum.GDT) {
        transferFundType = gdtFundTypeEnum.CREDIT_ROLL
      }

      return transferFundType
    },
    /**
     * @description: 获取并统一处理头条、腾讯广告的实时余额
     * @param {*} item 表格行
     * @param {*} adAccountId 账号id
     */
    async getAccountRealtimeBalance(item, adAccountId) {
      // 获取转出账号的实时余额
      const accountBalanceInfo = await getTransferAccountBalance({ adAccountId })

      let realtimeBalance = {}
      // 头条：默认授信余额
      if (item.mediaId === mediaTypeEnum.TOUTIAO) {
        realtimeBalance = accountBalanceInfo
      }
      // 腾讯广告：默认授信余额
      if (item.mediaId === mediaTypeEnum.GDT) {
        const credit = accountBalanceInfo.list.find((item) => item.fund_type === gdtFundTypeEnum.CREDIT_ROLL)
        const cash = accountBalanceInfo.list.find((item) => item.fund_type === gdtFundTypeEnum.CASH)
        const gift = accountBalanceInfo.list.find((item) => item.fund_type === gdtFundTypeEnum.GIFT)
        const virturl = accountBalanceInfo.list.find((item) => item.fund_type === gdtFundTypeEnum.VIRTUAL)
        const specialGift = accountBalanceInfo.list.find((item) => item.fund_type === gdtFundTypeEnum.SPECIAL_GIFT)

        // 腾讯广告余额单位为分，需要除100
        realtimeBalance = {
          // 授信余额
          bid_credit_valid: credit ? credit.balance / 100 : '-',
          // 现金余额
          bid_prepay_valid: cash ? cash.balance / 100 : '-',
          // 赠送余额
          grant_valid: gift ? gift.balance / 100 : '-',
          // 补偿虚拟金余额
          virturl_valid: virturl ? virturl.balance / 100 : '-',
          // 专项充值金
          special_gift_valid: specialGift ? specialGift.balance / 100 : '-',
          // 计算总余额
          total_transfer_balance: accountBalanceInfo.list.map((item) => item.balance).reduce((a, b) => a + b, 0) / 100
        }
      }

      return realtimeBalance
    },

    /**
     * @description: 获取可转入账号下拉列表
     */
    async getValidAccounts(adAccountId) {
      try {
        const data = await getValidTransferAccounts({ adAccountIdStr: adAccountId })
        return Promise.resolve(data?.length ? data : [])
      } catch (e) {
        return Promise.reject(new Error(e.message))
      }
    },

    calcBalance(value, finaRebate) {
      let balance = value * finaRebate
      balance = Object.is(NaN, balance) ? '' : balance.toFixed(2)
      return balance
    },
    onRechargeValueConfirm() {
      const { value } = this.form
      const newList = this.list.map((item) => {
        return { ...item, balance: this.calcBalance(value, item.finaRebate), realBalance: value }
      })
      this.$emit('update:list', newList)
    },

    buildRechargeParams() {
      return this.list.map((item) => {
        const platform = platformsList.find((p) => p.value === item.platform).label
        return {
          toAccountId: item.accountId,
          rebate: item.finaRebate,
          platform,
          platformId: item.platform,
          orderAmount: item.realBalance
        }
      })
    },
    buildTransferParams() {
      return this.list.map((item) => {
        const { id, finaRebate, mediaId } = item.transferAccountInfo
        return {
          toAccountId: item.accountId,
          fromAccountId: id,
          rebate: finaRebate,
          orderPaperUserAmount: item.transferBalance,
          mediaId: mediaId,
          mediaTransferType: item.transferFundType,
          isSelfDeal: item.isSelfDeal
        }
      })
    },

    buildTransferOutParams() {
      return this.list.map((item) => {
        const { id } = item.transferAccountInfo
        return {
          toAccountId: id,
          fromAccountId: item.accountId,
          rebate: item.finaRebate,
          orderPaperUserAmount: item.transferBalance,
          mediaId: item.mediaId,
          mediaTransferType: item.transferFundType,
          isSelfDeal: item.isSelfDeal
        }
      })
    },
    async onModalConfirm() {
      try {
        let taskList = []
        const { batchType: taskType } = this.form

        if (taskType === batchTypeEnum.RECHARGE) {
          await this.validateRechargeTable()
          taskList = this.buildRechargeParams()
        }

        if (taskType === batchTypeEnum.TRANSFER_IN) {
          await this.validateTransferTable()
          taskList = this.buildTransferParams()
        }

        if (taskType === batchTypeEnum.TRANSFER_OUT) {
          await this.validateTransferTable()
          taskList = this.buildTransferOutParams()
        }

        this.submitLoading = true

        const params = {
          taskType,
          taskList
        }

        financeAccountOrderApply(params)
          .then((res) => {
            res.taskList = res.taskList.map((item) => {
              let transferFundTypeDesc = ''

              if (item.mediaId === 10) {
                transferFundTypeDesc = toutiaoFundType.find((v) => v.value === item.mediaTransferType).label
              }

              if (item.mediaId === 16) {
                transferFundTypeDesc = gdtFundType.find((v) => v.value === item.mediaTransferType).label
              }

              return {
                ...item,
                transferFundTypeDesc
              }
            })

            this.$emit('result', res)

            this.onModalCancel()
          })
          .finally(() => {
            this.submitLoading = false
          })
      } catch (e) {
        this.$Message.warning(e)
      }
    },
    /**
     * @description: 切换方式后，重置列表数据，再渲染切换后的ui
     * @param {*} e
     */
    onHandleTypeChange(e) {
      this.$emit('reset-list')
      this.availableAccounts = {}

      this.$nextTick(() => {
        this.form.batchType = e
      })
    },
    onModalCancel() {
      this.visibleModal = false
      this.form = getForm()
    },
    validateRechargeTable() {
      try {
        for (const item of this.list) {
          if (!item.realBalance) {
            throw new Error('请输入充值金额')
          }

          if (Object.is(NaN, Number(item.realBalance))) {
            throw new Error('请输入数字')
          }

          if (item.realBalance <= 0) {
            throw new Error('充值金额须大于0')
          }

          if (!twoDigitsRegExp.test(item.realBalance)) {
            throw new Error('金额最多保留两位小数')
          }

          if (!item.platform) {
            throw new Error('请选择平台类型')
          }
        }

        return Promise.resolve()
      } catch (e) {
        return Promise.reject(e.message)
      }
    },
    validateTransferTable() {
      try {
        for (const item of this.list) {
          if (!item.transferAccountInfo?.id) {
            throw new Error('请选择账号')
          }

          if (!item.transferBalance) {
            throw new Error('请输入转账金额')
          }

          if (Object.is(NaN, Number(item.transferBalance))) {
            throw new Error('请输入数字')
          }

          if (item.transferBalance <= 0) {
            throw new Error('转账金额须大于0')
          }

          //  小数点后两位
          if (!twoDigitsRegExp.test(item.transferBalance)) {
            throw new Error('金额最多保留两位小数')
          }

          // 可转余额
          let validAmount = ''

          if (item.mediaId === 10) {
            if (item.transferFundType === toutiaoFundTypeEnum.CREDIT_BID) {
              validAmount = item.realtimeBalance.bid_credit_valid
            }

            if (item.transferFundType === toutiaoFundTypeEnum.PREPAY_BID) {
              validAmount = item.realtimeBalance.bid_prepay_valid
            }

            if (item.transferFundType === toutiaoFundTypeEnum.GRANT) {
              validAmount = item.realtimeBalance.grant_valid
            }
          }

          if (item.mediaId === 16) {
            if (item.transferFundType === gdtFundTypeEnum.CREDIT_ROLL) {
              validAmount = item.realtimeBalance.bid_credit_valid
            }

            if (item.transferFundType === gdtFundTypeEnum.CASH) {
              validAmount = item.realtimeBalance.bid_prepay_valid
            }

            if (item.transferFundType === gdtFundTypeEnum.GIFT) {
              validAmount = item.realtimeBalance.grant_valid
            }

            if (item.transferFundType === gdtFundTypeEnum.VIRTUAL) {
              validAmount = item.realtimeBalance.virturl_valid
            }

            if (item.transferFundType === gdtFundTypeEnum.SPECIAL_GIFT) {
              validAmount = item.realtimeBalance.special_gift_valid
            }
          }

          if ([10, 16].includes(item.mediaId)) {
            if (item.transferBalance > validAmount) {
              throw new Error('转出账面金额不能大于转出账面余额')
            }
          }
        }

        return Promise.resolve()
      } catch (e) {
        return Promise.reject(e.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-modal-title {
  font-size: 16px;
  display: flex;
  align-items: center;
  .selected-num {
    font-size: 13px;
    margin-left: 30px;
  }
}
</style>
